
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/login/LoginPage';
import DashboardPage from './components/dashboard/DashboardPage';
import InfoPage from './components/info/InfoPage';
import DetailsPage from './components/details/DetailsPage';

function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const userLoggedIn = await checkIfUserIsLoggedIn();
      setIsLoggedIn(userLoggedIn);
      setIsLoading(false);
    };
    checkAuthStatus();
  }, []);


  const checkIfUserIsLoggedIn = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        const token = localStorage.getItem('token');
        const expirationTime = localStorage.getItem("expiration");
        if (!token || !expirationTime) {
          resolve(false);
          return;
        }
        const now = new Date();
        const expiryDate = new Date(expirationTime);

        resolve(now < expiryDate);
      }, 200);
    });
  };

  const updateLoggedIn = (value) => {
    setIsLoggedIn(value);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <LoginPage updateLoggedIn={updateLoggedIn} />}
        />
        <Route path="/dashboard" element={isLoggedIn ? <DashboardPage /> : <Navigate to="/" replace />}
        />
        <Route path="/info" element={isLoggedIn ? <InfoPage /> : <Navigate to="/" replace />}
        />
        <Route path="/details" element={isLoggedIn ? <DetailsPage /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={isLoggedIn ? <DashboardPage /> : <Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;